// Self-heal after a deploy: when a lazily-loaded JS/CSS chunk 404s (the user is
// holding an old HTML that references hashed chunks which have since been replaced),
// Nuxt fires `app:chunkError`. Instead of a blank screen, do a full reload so the
// browser re-fetches the fresh (no-cache) HTML and its current chunk graph.
// `persistState` keeps the current route/state across the reload where possible.
export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:chunkError', () => {
        reloadNuxtApp({persistState: true})
    })
})
